import { render } from "./DarkModeToggler.vue?vue&type=template&id=bea8f46a&scoped=true"
import script from "./DarkModeToggler.vue?vue&type=script&lang=js"
export * from "./DarkModeToggler.vue?vue&type=script&lang=js"

import "./DarkModeToggler.vue?vue&type=style&index=0&id=bea8f46a&scoped=true&lang=css"

import exportComponent from "/home/admin/domains/web3.owatts.io/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bea8f46a"]])

export default __exports__